import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useMixpanel } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { InboxTaskType } from '@treams/treams-network';

import InboxTaskItem from '../components/InboxTaskItem';

export default function InboxFeedbackRequestPendingTask({
	task,
	tasks,
	finishedTask,
	type,
	onAction,
	refresh,
}: {
	task: graphql.InboxTask;
	tasks?: graphql.InboxTask[];
	finishedTask?: graphql.InboxTask;
	type?: InboxTaskType;
	onAction: () => void;
	refresh: () => void;
}) {
	const mixpanel = useMixpanel();
	const history = useHistory();
	const { t } = useTranslation();

	const feedbackResponse = task.feedbackResponse!;

	const { requestor } = feedbackResponse;

	const onClick = () => {
		mixpanel?.track('inbox.tasks.feedbackRequestPending.respond');
		onAction();
		if (type && type === InboxTaskType.FeedbackRequestPending) {
			history.push(
				`/users/${requestor.id}/feedback/${feedbackResponse.id}/respond?return=/feedback/given`,
			);
		} else {
			history.push(`/users/${requestor.id}/feedback/${feedbackResponse.id}/respond`);
		}
	};

	return (
		<InboxTaskItem
			task={task}
			tasks={tasks}
			finishedTask={finishedTask}
			title={t('inbox.tasks.feedbackRespondToOutstandingSelf.title', {
				targetEmployeeFullName: `${requestor.firstName} ${requestor.lastName}`,
			})}
			date={task.createdAt}
			buttonTitle={t('inbox.tasks.button.start')}
			onClick={onClick}
			refresh={refresh}
		/>
	);
}
